/* Archadia mirror hall: collection cards standing on a curved, mirrored floor. Drag, swipe, arrows, dots, keys. */
(() => {
  if (window.__archMirrorHall) { window.__archMirrorHall(); return; }

  function init(root) {
    if (!root || root.__mhInit) return;
    const stage = root.querySelector('[data-mh-stage]');
    const ring = root.querySelector('[data-mh-ring]');
    const src = Array.from(root.querySelectorAll('[data-mh-src] > .mh-card'));
    if (!stage || !ring || !src.length) return;
    root.__mhInit = true;

    const d = root.dataset;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const n = src.length;
    const spacing = parseFloat(d.spacing) || 15;
    const depth = (parseFloat(d.depth) || 0) / 100;
    const autoplay = (parseFloat(d.autoplay) || 0) * 1000;

    // stars
    const stars = root.querySelector('[data-mh-stars]');
    if (stars && !stars.childElementCount) {
      let html = '';
      for (let i = 0; i < 70; i++) {
        html += '<i style="left:' + (Math.random() * 100).toFixed(2) + '%;top:' + (Math.random() * 100).toFixed(2) + '%;--d:' + (2.5 + Math.random() * 4).toFixed(2) + 's;--dl:' + (-Math.random() * 6).toFixed(2) + 's;--o:' + (0.25 + Math.random() * 0.6).toFixed(2) + (Math.random() < .15 ? ';width:3px;height:3px' : '') + '"></i>';
      }
      stars.innerHTML = html;
    }

    // fill the ring: repeat the collections so the hall never looks empty at the edges
    const reps = Math.max(1, Math.ceil(16 / n));
    const cards = [];
    for (let r = 0; r < reps; r++) {
      src.forEach((c, i) => {
        const el = r === 0 ? c : c.cloneNode(true);
        if (r > 0) { el.setAttribute('aria-hidden', 'true'); el.setAttribute('tabindex', '-1'); el.removeAttribute('data-shopify-editor-block'); }
        el.dataset.idx = i;
        ring.appendChild(el);
        cards.push(el);
      });
    }
    const m = cards.length;

    const elCount = root.querySelector('[data-mh-count]');
    const elName = root.querySelector('[data-mh-name]');
    const elCta = root.querySelector('[data-mh-cta]');
    const dotsWrap = root.querySelector('[data-mh-dots]');
    const pad = (k) => String(k).padStart(2, '0');

    const dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (let i = 0; i < n; i++) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'mh-dot'; b.setAttribute('aria-label', 'Show ' + (src[i].dataset.name || i + 1));
        b.addEventListener('click', () => goIdx(i));
        dotsWrap.appendChild(b); dots.push(b);
      }
    }

    let W = 0, cardW = 200, R = 800;
    const measure = () => {
      W = stage.getBoundingClientRect().width;
      cardW = cards[0].offsetWidth || 200;
      const rad = spacing * Math.PI / 180;
      R = (cardW * (W < 750 ? 1.16 : 1.24)) / rad;
    };
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(stage); else window.addEventListener('resize', measure);

    let pos = 0, target = 0, active = -1;
    const wrap = (v) => { v = ((v % m) + m) % m; return v > m / 2 ? v - m : v; };
    const goIdx = (i) => {
      // nearest clone of collection i
      let best = 1e9, k = 0;
      cards.forEach((c, j) => { if (+c.dataset.idx === i) { const o = wrap(j - target); if (Math.abs(o) < Math.abs(best)) { best = o; k = j; } } });
      target = Math.round(target + best); touch(); kick();
    };
    const step = (s) => { target = Math.round(target) + s; touch(); kick(); };
    root.__mhGo = (el) => { const i = src.indexOf(el); if (i >= 0) goIdx(i); };

    const setName = (txt) => {
      if (!elName) return;
      elName.classList.remove('is-in');
      elName.innerHTML = '';
      Array.from(txt).forEach((ch, i) => {
        const s = document.createElement('span');
        s.textContent = ch === ' ' ? ' ' : ch;
        s.style.setProperty('--i', i);
        elName.appendChild(s);
      });
      void elName.offsetWidth;
      elName.classList.add('is-in');
    };

    const setActive = (k) => {
      if (k === active) return;
      active = k;
      const i = +cards[k].dataset.idx;
      const c = src[i];
      cards.forEach((el, j) => el.classList.toggle('is-active', j === k));
      dots.forEach((el, j) => el.classList.toggle('is-active', j === i));
      if (elCount) elCount.textContent = pad(i + 1);
      setName(c.dataset.name || '');
      const href = c.getAttribute('href') || '#';
      if (elName) elName.href = href;
      if (elCta) elCta.href = href;
    };

    // pointer: drag / swipe
    let dragging = false, moved = 0, startX = 0, startPos = 0, lastX = 0, lastT = 0, vel = 0, pid = null;
    stage.addEventListener('pointerdown', (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true; moved = 0; startX = lastX = e.clientX; startPos = pos; lastT = performance.now(); vel = 0; pid = e.pointerId;
      stage.classList.add('is-dragging'); touch(); kick();
    });
    window.addEventListener('pointermove', (e) => {
      if (!dragging || (pid != null && e.pointerId !== pid)) return;
      const dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      const now = performance.now();
      vel = (e.clientX - lastX) / Math.max(1, now - lastT);
      lastX = e.clientX; lastT = now;
      const pxPerCard = (spacing * Math.PI / 180) * R;
      pos = target = startPos - dx / pxPerCard;
    });
    const end = () => {
      if (!dragging) return;
      dragging = false; pid = null;
      stage.classList.remove('is-dragging');
      target = Math.round(pos - vel * 5);
      touch(); kick();
    };
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    stage.addEventListener('dragstart', (e) => e.preventDefault());

    cards.forEach((c, k) => {
      c.addEventListener('click', (e) => {
        if (moved > 6) { e.preventDefault(); moved = 0; return; }
        if (k !== active) { e.preventDefault(); target = Math.round(target + wrap(k - target)); touch(); kick(); }
      });
    });
    root.querySelector('[data-mh-prev]')?.addEventListener('click', () => step(-1));
    root.querySelector('[data-mh-next]')?.addEventListener('click', () => step(1));

    // horizontal trackpad scroll
    let wheelLock = 0;
    stage.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY) || Math.abs(e.deltaX) < 8) return;
      e.preventDefault();
      const now = performance.now();
      if (now - wheelLock < 280) return;
      wheelLock = now; step(e.deltaX > 0 ? 1 : -1);
    }, { passive: false });

    // visibility, intro and arrow keys
    let visible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((en) => {
        visible = en[0].isIntersecting;
        if (visible) { root.classList.add('mh-in'); kick(); }
      }, { threshold: 0.2 }).observe(root);
    } else { visible = true; root.classList.add('mh-in'); }
    window.addEventListener('keydown', (e) => {
      if (!visible) return;
      if (/INPUT|TEXTAREA|SELECT/.test((document.activeElement && document.activeElement.tagName) || '')) return;
      if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
    });

    // gentle parallax with the cursor
    let px = 0, py = 0, tx = 0, ty = 0, hovering = false;
    root.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = root.getBoundingClientRect();
      tx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      ty = ((e.clientY - r.top) / r.height - 0.5) * 2;
      kick();
    });
    root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') hovering = true; });
    root.addEventListener('pointerleave', () => { hovering = false; tx = ty = 0; kick(); });

    let lastUser = 0, lastAuto = performance.now();
    function touch() { lastUser = performance.now(); }

    // stagger the intro from the centre outwards
    cards.forEach((c, k) => c.style.setProperty('--mh-k', Math.round(Math.abs(wrap(k)))));

    let running = false;
    const kick = () => { if (!running) { running = true; requestAnimationFrame(frame); } };

    const frame = (now) => {
      if (autoplay && !reduce && visible && !dragging && !hovering && now - lastUser > autoplay * 1.5 && now - lastAuto > autoplay) {
        lastAuto = now; target = Math.round(target) + 1;
      }
      if (!dragging) pos += (target - pos) * (reduce ? 1 : 0.085);
      px += (tx - px) * 0.06; py += (ty - py) * 0.06;

      const mobile = W < 750;
      const maxA = mobile ? 62 : 74;
      const P = mobile ? 700 : 1100;
      const par = 'perspective(' + P + 'px) rotateY(' + (px * 3).toFixed(3) + 'deg) rotateX(' + (-py * 2).toFixed(3) + 'deg) ';
      for (let k = 0; k < m; k++) {
        const off = wrap(k - pos);
        const aDeg = off * spacing;
        const a = aDeg * Math.PI / 180;
        const el = cards[k];
        if (Math.abs(aDeg) > maxA + spacing) { if (el.style.visibility !== 'hidden') el.style.visibility = 'hidden'; continue; }
        el.style.visibility = '';
        const x = Math.sin(a) * R;
        const z = (1 - Math.cos(a)) * R * (0.25 + depth * 0.9);
        const near = Math.max(0, 1 - Math.abs(off));
        const lift = near * (mobile ? 6 : 10);
        const fade = Math.min(1, Math.max(0, (maxA + spacing - Math.abs(aDeg)) / spacing));
        el.style.transform = par + 'translate3d(' + x.toFixed(1) + 'px,' + (-lift).toFixed(1) + 'px,' + z.toFixed(1) + 'px) rotateY(' + (-aDeg * 0.92).toFixed(2) + 'deg)';
        el.style.opacity = fade.toFixed(3);
        el.style.zIndex = String(Math.round(z) + 1000);
        el.style.setProperty('--mh-shade', Math.min(1, Math.abs(off) / 4).toFixed(3));
        el.style.pointerEvents = fade < 0.4 ? 'none' : '';
      }
      setActive(((Math.round(pos) % m) + m) % m);
      const settled = !dragging && Math.abs(target - pos) < 0.0005 && Math.abs(tx - px) < 0.001 && Math.abs(ty - py) < 0.001;
      if (settled) pos = target;
      if (!settled || (autoplay && visible && !reduce)) requestAnimationFrame(frame); else running = false;
    };
    kick();
  }

  const boot = () => document.querySelectorAll('[data-mh]').forEach(init);
  window.__archMirrorHall = boot;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-mh]').forEach(init));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest && e.target.closest('[data-mh]');
    if (root && root.__mhGo) root.__mhGo(e.target);
  });
})();
